module.exports = __webpack_public_path__ + "img/Dental3DRender.2e955f86.png";